// extracted by mini-css-extract-plugin
export default {"DrawerItemContainer":"DrawerItem_DrawerItemContainer__zQowR","DrawerItemTitle":"DrawerItem_DrawerItemTitle__4CTa7","DrawerItemContent":"DrawerItem_DrawerItemContent__dl3st"};